import React, { useCallback, useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { Table } from "../../component/table/Table";
import { useDispatch } from "react-redux";
import { columnsConfig } from "./columnsDef";
import { downloadRequest } from "../../http-request/downloadFile";
import { toast } from "react-toastify";

import { openModal } from "../../store/modalSlice";
import { setProductListFilter } from "../../store/productListFilterSlice";

export const TablePage = ({ data }) => {
  const { category } = useParams();
  const [columnDefs, setColumnDefs] = useState([]);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleDownload = useCallback(
    async (rowData) => {
      console.log("DOWNLOAD clicked:", rowData);
      try {
        toast.success("downloading...");
        const fileData = await downloadRequest({
          category,
          requestId: rowData.request_id,
        });
        const contentType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([fileData], { type: contentType });

        // Create a temporary link element
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `mobiGarage_${rowData.request_id}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error("Error occurred during download:", err);
        toast.success("error while downloading");
      }
    },
    [category]
  );

  const handleOpenModal = useCallback(
    (rowData) => {
      dispatch(
        openModal({
          component: "DynamicForm",
          uiData: {
            heading: "Do you want to delete this record?",
            primaryButtonLabel: "Delete",
            secondaryButtonLabel: "Cancel",
          },
          configData: {
            category,
            ...rowData,
          },
          operationType: "delete",
        })
      );
    },
    [category, dispatch]
  );
  const handleStockOpenModal = useCallback(
    (rowData) => {
      console.log("STOCK MODAL clicked:", rowData);
      dispatch(
        openModal({
          component: "DynamicForm",
          uiData: {
            heading: "Do you want to Change the status?",
            primaryButtonLabel: "Change Status",
            secondaryButtonLabel: "Cancel",
          },
          configData: {
            category,
            ...rowData,
          },
          operationType: "update",
        })
      );
    },
    [category, dispatch]
  );
const handleProductList = useCallback(
  (inventory_id) => {
    console.log("PRODUCT LIST clicked:", inventory_id);
    navigate(`/${category}/${inventory_id}`);
  },
  [navigate, category]
);
  useEffect(() => {
    if (columnsConfig[category]) {
      setColumnDefs(
        columnsConfig[category](
          handleOpenModal,
          handleStockOpenModal,
          handleDownload,
          handleProductList
        )
      );
    }
  }, [
    category,
    handleOpenModal,
    handleDownload,
    handleStockOpenModal,
    handleProductList,
  ]);
  return <Table data={data} columns={columnDefs} />;
};
